import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

// เดิมประกาศซ้ำเป๊ะทั้งใน EduPortalManagementCreatePortal.jsx และ EditPortal.jsx
const DefaultTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        color: 'rgb(255, 255, 255)',
        borderRadius: '12px',
        boxShadow: theme.shadows[1],
        fontSize: 16,
    },
}));

export default DefaultTooltip;